"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const BasePromotion_1 = tslib_1.__importDefault(require("../promotions/BasePromotion"));
class GetNextBestInformationalResponseInformational extends BasePromotion_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '43f8970a-e808-4474-8f16-14d16297d456',
        description: 'Informational identifier',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalResponseInformational.prototype, "informationalId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 4, description: 'Promotion ranking' }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestInformationalResponseInformational.prototype, "ranking", void 0);
exports.default = GetNextBestInformationalResponseInformational;
